/* eslint-disable camelcase */
import React, { useContext, useEffect, useRef, useState } from 'react'
import { RhyBusAccordion, RhyBusAccordionItem } from '@rhybus/accordion'
import { RhyBusButton as Buttons } from '@rhybus/button';
import AddeditView from './add-edit'
import { COLUMN_NAMES, DELETE_ITEM, ListNames, NORESULT } from '../../config/configuration'
import PmgData from './pmgdata'

import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'
import { RhyBusNoresult } from '@rhybus/noresult'
import { RhyBusAlert } from '@rhybus/alert'
import { convertDate, DocumentIconNames, getFileExtensionByFileName } from '@rhybus/common-functions';
import { rhybusRListsHttp } from '../../api/rhybus-list-http';
import { UserContext, UserInitalValue } from '../../store/UserContextProvider';
import { getUserByUserId } from '../../config/configuration';

interface Item {
  Templates: string
}
const SettingsPMG = (props: any) => {
  const { me }: typeof UserInitalValue = useContext(UserContext)
  const [showedit, setShowedit] = useState(false)
  const [showAddPopup, setShowAddPopup] = useState(false)
  const [showAddEdit, setShowAddEdit] = useState(false)
  const [addFolderFile, setAddFolderFile] = useState(false)
  const [addFile, setAddFile] = useState(false)
  const [addFolder, setAddFolder] = useState(false)
  const [editFolder, setEditFolder] = useState(false)
  const [folderName, setFolderName] = useState<string>()
  const [section, setSection] = useState<string>()
  const [policyMemoItems, setPolicyMemoItems] = useState<any>([])
  const [accordionsArray, setAccordionsArray] = useState<any>([])
  const [folderNames, setFolderNames] = useState<any>([])
  const [filesArray, setFilesArray] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [flag, setFlag] = useState(true)
  const [showAlert, setShowAlert] = useState(false)
  const popupBodyRef = useRef<HTMLDivElement>(null)
  const [deleteDecision, setDeleteDecision] = useState<boolean>()
  const [deleteItem, setDeleteItem] = useState<Item | null>(null)
  const [folders, setFolders] = useState<any>([])
  const [AddType, setAddType] = useState(0)
  const [editFile, setEditFile] = useState(false)
  const [isConfirmed, setIsConfirmed] = useState<any>(false)
  const [deleteData, setDeleteData] = useState<any>()
  const [pmddata, setPMGData] = useState(true)
  const [toggleState, setToggleState] = useState<any>()
  const [generalFolder, setGeneralFolder] = useState<any>({
    files: [],
    generalKey: ''
  })
  const [generalFolderpmg, setGeneralFolderpmg] = useState<any>()
  const [files, setFiles] = useState<any[]>([])
  const [activeFileEdit, setActiveFileEdit] = useState<{ folderEKey: string; fileEKey: string } | null>(null)

  useEffect(() => {
    fetchData()
    toSetfolders()
  }, [flag])

  const btnBGColouredCRUDOperationsUI = {
    Add: {
      Label: 'Add',
      Icon: 'icon-add font-10 pe-lg-1 ',
      ClassName: 'btn btn-xs btn-primary whitetext font-0 font-lg-13 text-nowrap'
    },
    Submit: {
      Label: 'Submit',
      Icon: 'icon-save font-10 pe-lg-1',
      ClassName: 'btn btn-xs btn-primary whitetext font-0 font-lg-13 text-nowrap'
    },
    Save: {
      Label: 'Save',
      Icon: 'icon-save font-10 pe-lg-1 ',
      ClassName: 'btn btn-xs btn-primary whitetext font-0 font-lg-13 text-nowrap'
    },
    Update: {
      Label: 'Update',
      Icon: 'icon-update font-10 pe-lg-1',
      ClassName: 'btn btn-xs btn-primary whitetext font-0 font-lg-13 text-nowrap'
    },
    Delete: {
      Label: 'Delete',
      Icon: 'icon-delete font-10 pe-lg-1',
      ClassName: 'btn btn-xs btn-primary whitetext font-0 font-lg-13 text-nowrap'
    },
    Cancel: {
      Label: 'Cancel',
      Icon: 'icon-close color-primary font-10 pe-lg-1',
      ClassName: 'btn btn-xs btn-border1 font-0 font-lg-13 text-nowrap',
    },
  }

  const btnOutlinedCRUDOperationsUI = {
    Add: {
      Label: 'Add',
      Icon: 'icon-rb-add font-12 pe-lg-1',
      ClassName: 'btn-xs btn-border btn-border-radius3 color-primary font-0 font-lg-13 text-nowrap',
    },
    Edit: {
      Label: 'Edit',
      Icon: 'icon-rb-pencil font-12 pe-lg-1',
      ClassName: '',
    },
    Delete: {
      Label: 'Delete',
      Icon: 'icon-rb-trashbin font-12 pe-lg-1',
      ClassName: '',
    }
  }

  const fetchData = async () => {
    setLoading(true)
    const data = await getPolicyMemoFolders()
    setPolicyMemoItems(data)
    dataArray(data)
    setFlag(prev => prev)
    setLoading(false)
  }
  const SUPPORTED_FILE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'msg', 'ppt', 'pptx']
  const fileReturnType = (productMap: Map<string, unknown>) => {
    for (const [key, value] of productMap) {
      if (key === 'type') {
        return value
      }
    }
  }
  const FileTypes: { [key: string]: string } = { // Added index signature
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    gif: 'image/gif',
    jpe: 'image/jpeg',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    msg: '',
    pdf: 'application/pdf',
    png: 'image/png',
    pps: 'application/vnd.ms-powerpoint',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    txt: 'text/plain',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }
  function getFileType(fileName: string) {
    const extension = fileName.split('.').pop()
    return extension ? FileTypes[extension] : ''
  }
  async function openFile(
    file: any,
    ekey: string,
    listName: string
  ): Promise<void> {
    if (file) {
      const extension = getFileExtensionByFileName(file?.fileName)
      const list = await rhybusRListsHttp().getList(listName)
      await list
        .blobs()
        .getContent(ekey, file?.fileName, file?.folderName)
        .then(function (data: any) {
          const metadataMap =
            file?.metadata instanceof Map
              ? file?.metadata
              : new Map(Object.entries(file?.metadata || {})) // Added nullish coalescing
          let filetype = fileReturnType(metadataMap as Map<string, unknown>) // Type assertion
          if (filetype === undefined || filetype === '') {
            filetype = getFileType(file?.fileName)
          }
          const blob = new Blob([data], { type: filetype as string }) // Type assertion
          const blobURL = window.URL.createObjectURL(blob)
          const tempLink = document.createElement('a')
          tempLink.style.display = 'none'
          tempLink.href = blobURL

          if (extension && SUPPORTED_FILE_EXTENSIONS.includes(extension)) {
            tempLink.setAttribute('download', file?.fileName)
          } else {
            tempLink.setAttribute('target', '_blank')
          }
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
          setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(blobURL)
          }, 100)
        })
        .catch((error: any) => {
          console.error(error)
        })
    }
  }
  const getPolicyMemoFolders = async () => {
    const list = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO)
    const listItems = await list
      .query()
      .filter(`${COLUMN_NAMES.IsDeleted} eq false`)
      .select(
        COLUMN_NAMES.Path,
        COLUMN_NAMES.eKey,
        COLUMN_NAMES.eTag,
        COLUMN_NAMES.ItemModified,
        COLUMN_NAMES.ItemModifiedBy,
        COLUMN_NAMES.ItemCreatedBy,
        COLUMN_NAMES.ItemCreated
      )
      .expand(
        COLUMN_NAMES.ItemModifiedBy,
        COLUMN_NAMES.ItemCreatedBy
      )
      .orderBy([{ ascending: true, orderBy: COLUMN_NAMES.Path }])
      .get()
    const listItemstrue = await list
      .query()
      .filter(`${COLUMN_NAMES.IsDeleted} eq true`)
      .select(
        COLUMN_NAMES.Path,
        COLUMN_NAMES.eKey,
        COLUMN_NAMES.eTag,
        COLUMN_NAMES.ItemModified,
        COLUMN_NAMES.ItemModifiedBy,
        COLUMN_NAMES.ItemCreatedBy,
        COLUMN_NAMES.ItemCreated
      )
      .expand(
        COLUMN_NAMES.ItemModifiedBy,
        COLUMN_NAMES.ItemCreatedBy
      )
      .orderBy([{ ascending: true, orderBy: COLUMN_NAMES.Path }])
      .get()
    setDeleteData(listItemstrue)
    return listItems as any[]
  }

  const getFilesForFolder = async (eKey: string, filesToFilter?: any[]) => {
    const filesArr = filesToFilter ?? files
    const requiredBlobs = filesArr?.filter((blob) => blob?.itemKey === `${ListNames.POLICY_MEMO}__${eKey}`) // DSCACaseMaster used as PMG blob store
    if (!requiredBlobs?.length) return []
    const blobs = requiredBlobs[0]?.blobs
    if (!blobs?.length) return []
    const userIds = [...new Set(blobs.map((data: any) => data?.createdBy).concat(blobs.map((data: any) => data?.modifiedBy)))]
    const users = await Promise.all(userIds?.map((userId: any) => getUserByUserId(userId)))
    const userMap = new Map(users.map((user: any) => [user?.userId, user]))
    const filteredFiles = blobs.map((data: any) => ({
      ...data,
      ItemCreatedBy: userMap.get(data?.createdBy),
      ItemModifiedBy: userMap.get(data?.modifiedBy),
    }))
    return filteredFiles
  }
  const toSetfolders = async () => {
    setLoading(true);

    const folders = await getPolicyMemoFolders();
    const getFiles = async (listName: string) => {
      try {
        const list = await rhybusRListsHttp().getList(listName);
        const listBlobs: any = await list.blobs().listAll();
        return listBlobs;
      } catch (error) {
        console.error('Error fetching files:', error);
        if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
          throw new Error('Network error: Could not reach the server. Please check your connection or the API endpoint.');
        }

        throw error;
      }
    }
    // Use DSCACaseMaster blob store — PolicyMemoAndGuidelinesList is not configured for blob storage
    const files_img = await getFiles(ListNames.POLICY_MEMO);

    const generalFolder: any = folders?.filter(
      item => item?.Path?.toLowerCase() === 'general'?.toLowerCase()
    );


    const otherFolders = folders?.filter(
      item => item?.Path?.toLowerCase() !== 'general'?.toLowerCase()
    );

    setGeneralFolderpmg(otherFolders);

    const generalFiles = await getFilesForFolder(generalFolder?.[0]?.eKey, files_img);


    setFolders([...new Set(otherFolders)]);
    setFiles(files_img);

    setGeneralFolder({
      files: generalFiles,
      generalKey: generalFolder?.[0]?.eKey || null,
    });

    setLoading(false);
  };


  function addeditValue(showAddPopup: any) {
    setShowAddPopup(showAddPopup)
    setShowAddEdit(false)
    setEditFolder(false)
    setAddFolderFile(false)
    setAddFolder(false)
  }

  const [inEditMode, setInEditMode] = useState({
    status: false,
    rowKey: null,
  })

    const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

  const getUserDisplayName = (user: any): string => {
    if (!user) return ''
    if (typeof user === 'string') {
      if (UUID_PATTERN.test(user.trim())) return ''
      return user
    }
    return user?.properties?.defaultDisplay ?? user?.persona ?? user?.Title ?? user?.displayName ?? ''
  }

  const formatUserDate = (user: any, date: any): string => {
    const name = getUserDisplayName(user)
    const formattedDate = convertDate(date, 'date') ?? ''
    return name ? `${name} | ${formattedDate}` : formattedDate
  }
  function dataArray(policyMemoItems: any) {
    let accordionitems: any[] = []
    let folderNamesArray: any[] = []
    let filesitems: any[] = []
    policyMemoItems?.map((policymemoList: any) => {
      
      if (policymemoList?.Path !== 'Forms' && policymemoList?.Path !== 'general') {
        // Map each folder with its files
        accordionitems.push({
          ID: policymemoList?.eKey,
          eKey: policymemoList?.eKey,
          eTag: policymemoList?.eTag,
          IsDeleted: false,
          Templates: policymemoList?.Path,
          ItemCreatedBy: policymemoList?.ItemCreatedBy,
          ItemModifiedBy: policymemoList?.ItemModifiedBy,
          Created: formatUserDate(policymemoList?.ItemCreatedBy, policymemoList?.ItemCreated),
          Modified: formatUserDate(policymemoList?.ItemModifiedBy, policymemoList?.ItemModified),

          Files: acordioncontent(
            getFilesForFolder(policymemoList.eKey), policymemoList.Path,
          ),
          'Is Archived': '',
        })
        folderNamesArray.push({
          folderName: policymemoList?.Path,
        })
      }
    })
    console.log('Policy Memo Items:', policyMemoItems)
    // Sort files by Title within each folder
    filesitems?.sort((a: any, b: any) => a?.Path?.localeCompare(b?.Path))
    setFilesArray(filesitems)
    // Sort files within accordion items based on Title
    accordionitems?.forEach((item: any) => {
      if (item && Array.isArray(item.Files)) {
        const filesList = [...item.Files]
        filesList.sort((a: any, b: any) => a?.Path?.localeCompare(b?.Path))
        item.Files = filesList
      }
    })
    // Sort accordion items based on Template Title
    accordionitems?.sort((a: any, b: any) => a?.Templates?.localeCompare(b?.Templates))
    setAccordionsArray(accordionitems)
    setFolderNames(folderNamesArray)

  }


  function acordioncontent(list: any, clickedIndex?: any) {
    return (
      <PmgData
        list={list}
        showAddEdit={true}
        filtersvalue={addeditValue}
        addFile={addFile}
        addFolder={addFolder}
        addFolderFile={addFolderFile}
        AddType={AddType}
        folderClose={addFolderClick}
        folderName={folderName}
        editFolder={editFolder}
        details={accordionsArray}
        folderNames={folderNames}
        flag={flag}
        setFlag={setFlag}
        popupBodyRef={popupBodyRef}
        Section={section}
        files={files}
        fetchData={fetchData}
        toSetfolders={toSetfolders}
        pmddata={pmddata}
        setPMGData={setPMGData}
        setShowAddEdit={setShowAddEdit}
        setAddFolderFile={setAddFolderFile}
        setIsConfirmed={setIsConfirmed}
        generalFolderpmg={generalFolderpmg}
        setGeneralFolderpmg={setGeneralFolderpmg}
        activeFileEdit={activeFileEdit}
        onFileEditOpen={(folderEKey: string, fileEKey: string) => {
          setActiveFileEdit({ folderEKey, fileEKey })
          setEditFolder(false)
          setFolderName('')
        }}
        onFileEditClose={() => setActiveFileEdit(null)}
      />
    )
  }

  const onEdit = (item: any) => {
    setShowAddPopup(false)
    setInEditMode({
      status: true,
      rowKey: item.eKey,
    })
    setShowAddEdit(false)
    setFolderName(item?.Templates)
    setEditFolder(true)
    setActiveFileEdit(null)
    dataArray(policyMemoItems)
    setAddFile(false)
    setAddFolder(false)
    setEditFile(false)
    setAddFolderFile(false)
  }

  const onEditFile = (item: any) => {
    setShowAddPopup(false)
    setInEditMode({
      status: true,
      rowKey: item.eKey,
    })
    setShowAddEdit(false)
    setFolderName('')
    setEditFolder(false)
    setEditFile(true)
    setAddFile(false)
    setAddFolder(false)
    setAddFolderFile(false)
    setActiveFileEdit(null)
  }

  const onAccourdian = (item: any) => {
    setShowAddPopup(false)
    setInEditMode({
      status: false,
      rowKey: null,
    })
    dataArray(policyMemoItems)
    setEditFolder(false)
    setAddFolderFile(false)
  }

  useEffect(() => {
    setShowAlert(false)
  }, [deleteDecision])

  const onDelete = (item: any) => {
    setDeleteItem(item)
    setShowAlert(true)
  }

  const onClickAlert = async (button: string, item: any, itemKey: string) => {
    if (button === 'YES' && item?.Created) {
      setShowAlert(false)
      if (deleteItem) {
        setLoading(true)
        const folderList = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO)
        const blobList = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO)
        const files = await getFilesForFolder(item.eKey)

        try {
          await Promise.all(
            files.map((file: any) =>
              blobList.blobs().delete(
                item?.eKey as string,
                file?.fileName,
                file?.folderName,
                file?.eTag
              )
            )
          )
        } catch (error) {
          console.error('Error while deleting files:', error)
        }

        const updateObject = {
          eKey: item.eKey,
          eTag: item.eTag,
          IsDeleted: true,
          ItemModified: new Date().toISOString(),
          ItemModifiedBy: me?.persona
        }
        await folderList.addOrUpdateItem(updateObject)
        setFlag(!flag)
        setLoading(false)
        setDeleteItem(null)
      }
    }
    if (button === 'YES' && !item?.Created) {
      const list = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO)
      try {
        // Attempt to delete the file
        await list.blobs().delete(
          itemKey,
          item?.fileName,
          item?.folderName,
          item?.eTag
        )
      } catch (error) {
        console.error('Error during deletion:', error)
      } finally {
        // Close alert and reset state
        setFlag(!flag)
        setShowAlert(false)
        setDeleteItem(null)
      }
      setIsConfirmed(false)
    }
    else {
      setShowAlert(false)
      setDeleteItem(null)
    }
  }


  const onDeleteAttachments = async (item: any, itemKey: string) => {
    setDeleteItem(item)
    setShowAlert(true)
    const list = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO)
    setLoading(true)
    if (isConfirmed) {
      try {
        // Attempt to delete the file
        await list.blobs().delete(
          itemKey,
          item?.fileName,
          item?.folderName,
          item?.eTag
        )
      } catch (error) {
        console.error('Error during deletion:', error)
      } finally {
        // Close alert and reset state
        setFlag(!flag)
        setShowAlert(false)
        setDeleteItem(null)
      }
      setIsConfirmed(false)
    }
    setLoading(false)
  }

  const addFolderClick = (value: any) => {
    setShowAddEdit(!value)
    setAddFolder(!value)
  }

  const onAdd = (item: any) => {
    setSection('')
    setShowAddPopup(false)
    setInEditMode({
      status: true,
      rowKey: item,
    })

    setShowAddEdit(false)
    setAddFile(false)
    setAddFolder(false)
    setFolderName(item?.Templates)
    setAddFolderFile(true)
    dataArray(policyMemoItems)
    setEditFolder(false)
  }

  function showEditPopup(ele: any) {
    setShowedit(ele)
  }

  useEffect(() => {
    if ((showAddPopup || inEditMode) && popupBodyRef.current) {
      const focusableElements = popupBodyRef.current.querySelectorAll(
        'button, [href], input,  select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      if (focusableElements.length > 0) {
        (focusableElements[0] as HTMLElement).focus()
      }
    }
  }, [showAddPopup, inEditMode])

  const onCancel = () => {
    setInEditMode({
      status: false,
      rowKey: null,
    })
    setEditFile(false)
  }

  return (
    <>
      {loading ? (
        <PageOverlay />
      ) : (
        <div className='rb-metadata-settings'>
          <div className='settings-title mt-0 p-0 d-flex justify-content-between align-items-center px-1 mb-3'>
            <h2
              tabIndex={0}
              aria-label='Policy Memos & Guidelines'
              className='rb-settings-header-title'
            >
              Policy Memos & Guidelines
            </h2>
            <div className='d-flex align-items-center gap-2'>
              <Buttons
                leftIcon='icon-rb-add font-12'
                label={`${btnBGColouredCRUDOperationsUI.Add.Label} File`}
                className={btnBGColouredCRUDOperationsUI.Add.ClassName}
                onClick={() => {
                  setShowAddEdit(true)
                  setAddFile(true)
                  setAddFolder(false)
                  setEditFolder(false)
                  setAddFolderFile(false)
                  setFolderName('')
                  setSection('outer')
                  setInEditMode({
                    status: false,
                    rowKey: null,
                  })
                }}
              />
              <Buttons
                leftIcon='icon-rb-add'
                label={`${btnBGColouredCRUDOperationsUI.Add.Label} Folder`}
                className={btnBGColouredCRUDOperationsUI.Add.ClassName}
                onClick={() => {
                  setShowAddEdit(true)
                  setAddFolder(true)
                  setSection('')
                  setAddFile(false)
                  setEditFolder(false)
                  setAddFolderFile(false)
                  setFolderName('')
                  setInEditMode({
                    status: false,
                    rowKey: null,
                  })
                }}
              />
            </div>
          </div>
          <div className='p-0 settings-main m-0 p-1'>
            {showAddEdit && (
              <AddeditView
                showAddEdit={showAddEdit}
                setShowAddEdit={setShowAddEdit}
                filtersvalue={addeditValue}
                addFile={addFile}
                addFolder={addFolder}
                addFolderFile={addFolderFile}
                setAddFolderFile={setAddFolderFile}
                folderClose={addFolderClick}
                folderName={folderName}
                setFolderName={setFolderName}
                editFolder={editFolder}
                details={accordionsArray}
                folderNames={folderNames}
                flag={flag}
                setFlag={setFlag}
                popupBodyRef={popupBodyRef}
                Section={section}
                files={files}
                fetchData={fetchData}
                toSetfolders={toSetfolders}
                showAddPopup={showAddPopup}
                setShowAddPopup={setShowAddPopup}
                deleteData={deleteData}
              />
            )}
            {accordionsArray.length > 0 && accordionsArray.map((item: any, index: number) => (
              <div key={item.ID}>
                <RhyBusAccordion className='accordions' defaultOpenItems={index === 0 ? [0] : []}>
                  <RhyBusAccordionItem
                    index={0}
                    accordionActiveClass='settings-bordered whitebg mb-2'
                    onHeaderClick={() => onAccourdian(item)}
                    expandIcon='icon-rb-folder-open font-16 color-primary'
                    collapseIcon='icon-rb-folder-close-fill font-16 color-primary'
                    iconPosition='left'
                    headerType='metadata'
                    header={<span className='font-14 darktext'>{item.Templates}</span>}
                    metaRight={
                      <div className='d-flex align-items-center flex-nowrap last-child-hide'>
                        <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-block-md'></div>
                        <div className='text-break min-w-md-200 max-w-md-200'>
                          <span className='rb-card-header-item-title font-13 d-block'>Created</span>
                          <span className='darktext font-14'>{item.Created}</span>
                        </div>
                        <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-block-md'></div>
                        <div className='text-break min-w-md-150 max-w-md-150'>
                          <span className='rb-card-header-item-title font-13 d-block'>Modified</span>
                          <span className='darktext font-14'>{item.Modified}</span>
                        </div>
                        <div className='d-flex gap-1 settings-actionbtns mx-2 mx-xxl-3'>
                          <Buttons
                            label={btnOutlinedCRUDOperationsUI.Edit.Label}
                            leftIcon={btnOutlinedCRUDOperationsUI.Edit.Icon}
                            className={btnOutlinedCRUDOperationsUI.Edit.ClassName}
                            onClick={(e: any) => { e.stopPropagation(); onEdit(item); }}
                            variant='secondary'
                          />
                          <Buttons
                            label={btnOutlinedCRUDOperationsUI.Delete.Label}
                            leftIcon={btnOutlinedCRUDOperationsUI.Delete.Icon}
                            className={btnOutlinedCRUDOperationsUI.Delete.ClassName}
                            onClick={(e: any) => { e.stopPropagation(); onDelete(item); }}
                            variant='secondary'
                          />
                          <Buttons
                            label={btnOutlinedCRUDOperationsUI.Add.Label}
                            leftIcon={btnOutlinedCRUDOperationsUI.Add.Icon}
                            className={btnOutlinedCRUDOperationsUI.Add.ClassName}
                            onClick={(e: any) => { e.stopPropagation(); onAdd(item); }}
                            variant='secondary'
                          />
                        </div>
                      </div>
                    }
                  >
                    <div className='p-0 whitebg'>{acordioncontent(item, index)}</div>
                  </RhyBusAccordionItem>
                </RhyBusAccordion>
                {(editFolder || addFolderFile) && item.Templates === folderName && (
                  <AddeditView
                    showAddEdit={showAddEdit}
                    setShowAddEdit={setShowAddEdit}
                    filtersvalue={addeditValue}
                    addFile={addFile}
                    addFolder={addFolder}
                    addFolderFile={addFolderFile}
                    setAddFolderFile={setAddFolderFile}
                    folderClose={addFolderClick}
                    folderName={folderName}
                    setFolderName={setFolderName}
                    editFolder={editFolder}
                    details={accordionsArray}
                    folderNames={folderNames}
                    flag={flag}
                    setFlag={setFlag}
                    popupBodyRef={popupBodyRef}
                    Section={section}
                    files={files}
                    fetchData={fetchData}
                    toSetfolders={toSetfolders}
                    showAddPopup={showAddPopup}
                    setShowAddPopup={setShowAddPopup}
                    deleteData={deleteData}
                  />
                )}
              </div>
            ))}
            {/* <PmgData files={files} folder={accordionsArray} flag={flag} setFlag={setFlag} popupBodyRef={popupBodyRef} Section={section} /> */}
            {generalFolder.files?.length > 0 && generalFolder.files?.map((item: any, i: number) =>
              <>
                <div
                  className='d-flex flex-column whitebg settings-bordered my-3 p-2 border-radius-2'
                  key={item?.fileName}
                >
                  <div className='d-flex'>
                    <div className='d-flex flex-column flex-row-md flex-nowrap w-100'>
                      <div className='d-flex  align-items-center me-auto text-break font-12'>
                        <span className={`${DocumentIconNames(item?.fileName)} color-primary pe-1 font-14`}></span>
                        <a tabIndex={0} aria-label={item.fileName}
                          onKeyDown={(e: any) => {
                            if (e.key === 'Enter') { openFile(item, item?.eKey, ListNames.POLICY_MEMO) }
                          }}
                          onClick={() => { openFile(item, generalFolder?.generalKey, ListNames.POLICY_MEMO) }} download target="_blank" title={item.fileName} rel="noreferrer"
                          className="links1 fw-semibold font-13 links-over-underline links">{item.fileName}
                        </a>
                        {/* <span className='segoeui-semibold'>
                          {' '}
                          <a href={`/path/to/file/${item.fileName}`} tabIndex={0} aria-label={item.fileName} onKeyDown={(e:any) => {if (e.key === 'Enter'){openFile(item, generalFolder?.generalKey, ListNames?.POLICY_MEMO)}}} onClick={() => {openFile(item, generalFolder?.generalKey, ListNames?.POLICY_MEMO)}} download target="_blank" rel="noreferrer"
                            className='color-primary links cursor' title={item.fileName}>
                            {item.fileName}
                          </a> */}

                      </div>

                      <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-block-md'></div>
                      <div
                        className='d-flex flex-column min-w-md-150 w-100 max-w-md-150 text-break font-12'
                        tabIndex={0}
                        aria-live='polite'
                      >
                        <span className='rb-card-header-item-title font-13 '>
                          Created
                        </span>
                        <span className=' rb-card-header-item-subtitle'>
                          {formatUserDate(item?.ItemCreatedBy, item?.createdOn)}
                        </span>
                      </div>
                      <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-block-md'></div>
                      <div
                        className='d-flex flex-column min-w-md-150 w-100 max-w-md-150 text-break font-12'
                        tabIndex={0}
                        aria-live='polite'
                      >
                        <span className='rb-card-header-item-title font-13 '>
                          Modified
                        </span>
                        <span className=' rb-card-header-item-subtitle '>
                          {item?.ItemModifiedBy?.persona +
                            ' | ' +
                            convertDate(item?.modifiedOn, 'date')}
                        </span>
                      </div>
                      <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-block-md'></div>
                    </div>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex align-items-center gap-1 ms-auto'>
                        <Buttons
                          leftIcon={btnOutlinedCRUDOperationsUI.Edit.Icon}
                          label={btnOutlinedCRUDOperationsUI.Edit.Label}
                          className={btnOutlinedCRUDOperationsUI.Edit.ClassName}
                          onClick={() => onEditFile(item)}
                          variant='secondary'
                        />
                        <Buttons
                          leftIcon={btnOutlinedCRUDOperationsUI.Delete.Icon}
                          label={btnOutlinedCRUDOperationsUI.Delete.Label}
                          className={btnOutlinedCRUDOperationsUI.Delete.ClassName}
                          onClick={() => onDeleteAttachments(item, generalFolder?.generalKey)}
                          variant='secondary'
                        />
                      </div>
                    </div>
                  </div>
                  {inEditMode.status &&
                    inEditMode?.rowKey === item?.eKey ? (
                    <AddeditView
                      cancel={() => onCancel()}
                      filtersvalue={addeditValue}
                      showAddEdit={showAddPopup}
                      setShowAddEdit={setShowAddEdit}
                      // folderName={editFileName}
                      editFile={editFile}
                      editFileValue={item?.fileName}
                      details={props?.list}
                      editFileItem={item}
                      FolderId={generalFolder?.generalKey}
                      flag={props?.flag}
                      setFlag={props?.setFlag}
                      popupBodyRef={popupBodyRef}
                      Section={props?.Section}
                      fetchData={fetchData}
                      toSetfolders={toSetfolders}
                    />
                  ) : (
                    ''
                  )}
                </div>
              </>
            )
            }
            {accordionsArray.length == 0 && generalFolder.files?.length == 0 &&
              <div className='min-h-200 d-flex align-items-center justify-content-around whitebg settings-bordered'>
                <RhyBusNoresult />
              </div>}
          </div>
          {showAlert && (
            <RhyBusAlert
              size='md'
              show={showAlert}
              variant='confirm'
              message={DELETE_ITEM}
              confirmLabel='YES'
              cancelLabel='NO'
              onConfirm={() => onClickAlert('YES', deleteItem, generalFolder?.generalKey)}
              onCancel={() => onClickAlert('NO', deleteItem, generalFolder?.generalKey)}
            />
          )}
        </div>
      )}
    </>
  )
}
export default SettingsPMG


